import { IHotelStaticInfo } from './../core/models/HotelStaticInfo/hotelStaticInfo.interface';
import { createAction, props } from '@ngrx/store';

export const setHotelStaticInfo = createAction(
  '[HotelStatic] setHotelStaticInfo',
  props<{ hotelStaticInfo: IHotelStaticInfo }>(),
);
